import React from "react";
import { Mail } from "lucide-react";

interface BusinessProposalFooterProps {
  email?: string;
}

const BusinessProposalFooter: React.FC<BusinessProposalFooterProps> = ({
  email = "support@getglossa.com",
}) => {
  return (
    <footer className="bg-white border-t border-gray-100 mt-auto">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex items-center gap-3">
            <img
              src="/Glossa-Logo-1.png"
              alt="Glossa"
              className="h-7 w-auto object-contain opacity-90"
              onError={(e) => {
                (e.target as HTMLImageElement).src = "/logo.svg";
              }}
            />
            <p className="text-xs text-gray-500">
              © {new Date().getFullYear()} Glossa. All rights reserved.
            </p>
          </div>

          <a
            href={`mailto:${email}`}
            className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-[#885ABB] transition-colors"
          >
            <Mail className="w-4 h-4 text-[#885ABB]" />
            <span>{email}</span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default BusinessProposalFooter;
